import request from '../../../helpers/request';

const getHouseAttachment = async (houseId, fileName) => {
  const response = await request.get(
    `/HousingStock/house/${houseId}/attachment`,
    {
      fileName,
    },
    'Не удалось загрузить файл'
  );

  return response;
};

export default getHouseAttachment;
